import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ValidatorFn } from '@angular/forms';
import { markAllAsTouched } from '../../../../../utils/markAllAsTouched';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { languageLevels } from '../../../../../utils/language-levels';
import { commonEuropeanLanguages } from '../../../../../utils/languages';
@Component({
  selector: 'app-edit-language-modal',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule, CommonModule, MatSelectModule, MatOptionModule, TranslateModule],
  templateUrl: './edit-language-modal.component.html',
  styleUrl: '../edit-modal.scss'
})
export class EditLanguageModalComponent {

  languageForm: FormGroup;
  loading: boolean = false;

  // Native selects: treat an empty placeholder ('') and a missing value (null) as the same value
  sameValue = (a: any, b: any) => (a ?? '') === (b ?? '');
  languages = commonEuropeanLanguages;
  languageLevels = languageLevels;

  // Custom validator to check if the date is valid
  dateValidator: ValidatorFn = (control: AbstractControl): { [key: string]: boolean } | null => {
    const dateValue = control.value;
    const year = new Date(dateValue).getFullYear();
    return isNaN(year) || year.toString().length !== 4 ? { invalidDate: true } : null;
  };

  constructor(
    public dialogRef: MatDialogRef<EditLanguageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder 
  ) {
    
    this.languageForm = this.fb.group({
      language: [this.data.language.language || '', Validators.required ],
      languageLevel: [this.data.language.languageLevel || '', Validators.required ]
    });

  }

  close(): void {
    this.dialogRef.close();
  }

  saveEditLanguage() {
    if (this.languageForm.valid) {
        const editedLanguage = {
            language: this.languageForm.get('language')?.value,
            languageLevel: this.languageForm.get('languageLevel')?.value
        };
        this.dialogRef.close(editedLanguage);
    } else {
        markAllAsTouched(this.languageForm); // Mark all fields as touched to show validation errors
    }
  }
}
